import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { Divider, Paper } from '@material-ui/core';
import { createElement, FC } from 'react';

import { UserOptimizer } from '../../../graphql/generated/graphql';
import { SingleOfferFragment } from '../../../graphql/generated/graphql_offer';
import { ProjectType } from '../../../service/persistent/ProjectWebApi';
import DummyOfferDisplay from '../../component/compound/DummyOfferDisplay';
import DummyProjectForOfferDisplay from '../../component/compound/DummyProjectForOfferDisplay';
import OfferDisplay from '../../component/compound/OfferDisplay';
import ProjectForOfferDisplay from '../../component/compound/ProjectForOfferDisplay';
import _Breadcrumbs from '../../connected/Breadcrumbs';
import { SPACING_LARGE, SPACING_UNIT } from '../../constant/spacing';
import OfferAction from './OfferAction';
import { OfferDetailTab } from './Tabs/OfferDetailTab';

interface Props {
  offer: SingleOfferFragment | null;
  project: ProjectType | null;
  hasProjectChange: boolean;
  assetFiles: ReadonlyArray<FileReference>;
  briefFiles: Map<string, FileReference[]>;
  loading: boolean;
  mutating?: boolean;
  defaultTab?: string;
  signedInUser: UserOptimizer;
  applyForOffer: (offerId: string) => void;
  className?: string;
}

const OfferDetailPage: FC<Props> = ({
  offer,
  project,
  hasProjectChange,
  assetFiles,
  briefFiles,
  loading,
  mutating,
  defaultTab,
  signedInUser,
  applyForOffer,
  className,
}) => {
  const projectDisplay =
    !loading && offer ? (
      <ProjectForOfferDisplay offer={offer} organization={{ name: offer.organization.name }} />
    ) : (
      <DummyProjectForOfferDisplay />
    );

  const offerDisplay =
    !loading && offer ? (
      <OfferDisplay
        offer={offer}
        action={
          <OfferAction offer={offer} applyForOffer={applyForOffer} mutating={mutating} signedInUser={signedInUser} />
        }
      />
    ) : (
      <DummyOfferDisplay />
    );

  return (
    <Root className={className}>
      <Breadcrumbs />
      <OfferDetail>
        {projectDisplay}
        <Divider />
        {offerDisplay}
      </OfferDetail>
      <OfferDetailTab
        offer={offer}
        project={project}
        hasProjectChange={hasProjectChange}
        assetFiles={assetFiles}
        briefFiles={briefFiles}
        loading={loading}
        defaultTab={defaultTab}
      />
    </Root>
  );
};

const Root = styled('div')({
  margin: `0 ${SPACING_UNIT}px`,
  padding: `${SPACING_UNIT * 5}px calc((100% - 960px) / 2) ${SPACING_UNIT * 10}px`,
});

const Breadcrumbs = styled(_Breadcrumbs)({ marginBottom: SPACING_UNIT * 5 });

const OfferDetail = styled(Paper)({
  marginBottom: SPACING_LARGE,
});

export default OfferDetailPage;
